export default {"src":"/_next/static/media/ballon_ride.b447e92f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};